import { render, staticRenderFns } from "./BaseFormInlineMessage.vue?vue&type=template&id=20b3f4d2&functional=true"
import script from "./BaseFormInlineMessage.vue?vue&type=script&lang=js"
export * from "./BaseFormInlineMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports